import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getKey} from '../../../apis/user/getKey'

const useQueryKeyDetail = (id?: string) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.other.getKeyDetail(id),
        queryFn: async () => {
            const {data} = await getKey(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data, refetch, isLoading}
}

export default useQueryKeyDetail
